import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { Position } from './position';
export { Position };
import { positionSchema } from '@schemas/business-objects/position';
import { OrganizationFormGroup } from './organization-form-group';
import { PlacementFormArray } from './placement-form-group';
import { StaffTypeFormGroup } from './staff-type-form-group';
import { VenueFormGroup } from './venue-form-group';

export class PositionFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    staffTypeId: SchemaFormControl;
    staffType: StaffTypeFormGroup;
    venueId: SchemaFormControl;
    venue: VenueFormGroup;
    organizationId: SchemaFormControl;
    organization: OrganizationFormGroup;
    placements: PlacementFormArray;
  };

  declare value: Partial<Position>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(positionSchema, Position, data, options);
  }

  get object(): Position {
    return new Position(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'staffType':
        return new StaffTypeFormGroup();
      case 'venue':
        return new VenueFormGroup();
      case 'organization':
        return new OrganizationFormGroup();
      case 'placements':
        return new PlacementFormArray();
      default:
        return undefined;
    }
  }
}

export class PositionFormArray extends PersistedFormArray {
  readonly entityName = 'Position' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(positionSchema, Position, options);
  }

  protected override createItemGroup() {
    return new PositionFormGroup();
  }

  get array(): Position[] {
    return this.controls.map((group: PositionFormGroup) => group.object);
  }
}

export class PositionPersistedArray extends PersistedArray<Position> {
  readonly entityName = 'Position' as const;

  constructor(options?: PersistedArrayOptions) {
    super(Position, options);
  }
}
